import React, { useState } from "react";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import CreateClaim from "./CreateClaim";
import ClaimInfo from "./ClaimInfo";
import CancelClaim from "./CancelClaim";
import { useDispatch } from "react-redux";
import {
  useTrackSliderOrderMutation,
  useCancelSliderOrderMutation,
} from "redux/Logistic/SliderService";
import { UTILS } from "utils";
import { LoaderAction } from "redux/actions";
import { errorHandler } from "api/api/errorHandler";
import ModalTabs from "logistic-integrations/components/Tabs";
import SliderSupport from "./SliderSupport";
const { TabPane } = Tabs;
const DeliveryService = (props) => {
  const { t } = useTranslation();
  const { setOpen, order } = props;
  const dispatch = useDispatch();
  const [sliderOrder, setSliderOrder] = useState(null);
  const [trackSliderOrder] = useTrackSliderOrderMutation();
  const [cancelSliderOrder] = useCancelSliderOrderMutation();

  /*handle tab chnge */
  const handleTabChange = async (key) => {
    if (key === "3") {
      await getSliderOrderStatus();
    }
    await props.fetchOrderDetailsByID();
  };

  const getSliderOrderStatus = async () => {
    try {
      if (!order?._id) return;
      dispatch(LoaderAction.setLoading(true));
      const data = await trackSliderOrder({
        orderId: order._id,
      });
      if (data?.data?.success === 1 && data?.data?.data) {
        setSliderOrder(data?.data.data);
      } else {
        UTILS.errorNotification(errorHandler(data?.error));
        setSliderOrder(null);
      }
    } catch (error) {
      UTILS.errorNotification(errorHandler(error?.error));
    } finally {
      dispatch(LoaderAction.setLoading(false));
    }
  };

  const cancelsliderOrder = async () => {
    try {
      dispatch(LoaderAction.setLoading(true));
      if (!order?._id || !order?.storeId) return;
      const data = await cancelSliderOrder({
        orderId: order._id,
        storeId: order?.storeId
      });
      if (data?.data?.success === 1) {
        UTILS.successNotification(
          data?.data?.message || t("Order has been cancelled successfully")
        );
      } else {
        UTILS.errorNotification(errorHandler(data?.error));
      }
      await props.fetchOrderDetailsByID();
    } catch (error) {
    } finally {
      dispatch(LoaderAction.setLoading(false));
    }
  };

  return (
    <ModalTabs setOpen={setOpen} handleTabChange={handleTabChange}>
      <TabPane tab={t("SEND ORDER")} key="1">
        <CreateClaim
          fetchOrderDetailsByID={props.fetchOrderDetailsByID}
          customKey="create-claim"
        />
      </TabPane>
      <TabPane tab={t("ORDER DETAIL")} key="3">
        <ClaimInfo
          key="order-status"
          sliderOrder={sliderOrder}
          getsliderOrderStatus={getSliderOrderStatus}
        />
      </TabPane>
      <TabPane tab={t("CANCEL ORDER")} key="4">
        <CancelClaim
          key="cancel-claim"
          cancelsliderOrder={cancelsliderOrder}
          sliderOrder={sliderOrder}
        />
      </TabPane>
      <TabPane tab={t("SLIDER SUPPORT CENTER")} key="5">
        <SliderSupport sliderOrder={sliderOrder} />
      </TabPane>
    </ModalTabs>
  );
};

export default DeliveryService;
